export const facilityReviewSuccessMsg = (payload) => {
  if (payload && payload.featured_on_homepage && !payload.content) {
    return "Successfully added review on the homepage";
  } else if (payload && !payload.featured_on_homepage && !payload.content) {
    return "Successfully removed review from the homepage";
  } else if (payload && payload.facility_id) {
    return "Successfully updated review";
  }
  return "Successfully saved changes";
};
